<template>
  <div class="dialog">
    <el-dialog title="学生重大经历" :visible.sync="lifeExperienceDialogShow" width="900px" :before-close="dialogClose"
      @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top"
        :inline="true">
        <!-- <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <el-date-picker style="width: 235px" v-model="ruleForm.schoolYear" type="year" value-format="yyyy"
            placeholder="请选择学年" @change="schoolYearChangeHandle">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 备注 -->
        <el-form-item label="选择经历" prop="experience">
          <el-checkbox-group v-model="ruleForm.experience">
            <el-checkbox v-for="item in importantEventOptions" :key="item.dictValue" :label="item.dictLabel" border
              size="medium" style="margin-right: 10px;"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" placeholder="请输入备注" :autosize="{ minRows: 4, maxRows: 6 }"
            v-model="ruleForm.remarks" :maxlength="maxlength" show-word-limit style="width: 750px"></el-input>
        </el-form-item>
      </el-form>
      <div class="form-btn">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'lifeExperienceDialogShow',
    'semesterOptions',
    'importantEventOptions',
    'studentInfo'
  ],
  data() {
    return {
      isEdit: false,
      maxlength: 100,
      ruleForm: {
        id: "",
        schoolYear: "",
        semester: "",
        remarks: "",
        experience: []
      },
      rules: {
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        experience: [{ type: 'array', required: true, message: '请至少选择一个经历', trigger: 'change' }],
        remarks: [{ required: false, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.ruleForm.schoolYear = this.school.schoolYear;
    this.ruleForm.semester = this.school.semester;
    this.getStudentExperience();
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
    },
    getStudentExperience() {
      let data = {
        studentId: this.studentInfo.id,
        schoolYear: this.school.schoolYear,
        semester: this.school.semester
      };
      this.get(this.$url.selectStudentExperience, data).then(res => {
        // console.log("重大经历:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        if (res.data) {
          // 将状态字符串转换为数组
          const statusArray = res.data.status.split(',');

          this.ruleForm.id = res.data.id;
          this.ruleForm.remarks = res.data.remark;

          // 映射出符合条件的新数组
          this.ruleForm.experience = this.importantEventOptions.filter(item => statusArray.includes(item.dictValue))
            .map(item => item.dictLabel);
          this.isEdit = true;
        }
        // console.log("this.ruleForm:", this.ruleForm);
      });
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:lifeExperienceDialogShow", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm, this.isEdit);
          if (this.isEdit) {
            this.editStudentExperience();
          } else {
            this.addStudentExperience();
          }
        } else {
          return false;
        }
      });
    },
    editStudentExperience() {
      // 构建 label 到 value 的映射对象
      const labelToValue = Object.fromEntries(
        this.importantEventOptions.map(item => [item.dictLabel, item.dictValue])
      );
      let data = {
        "id": this.ruleForm.id,
        "studentId": this.studentInfo.id,
        "studentName": this.studentInfo.studentName,
        "status": this.ruleForm.experience
          .map(label => labelToValue[label])
          .join(','),
        "remark": this.ruleForm.remarks
      };
      this.put(this.$url.updateStudentExperience, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
      });
    },
    addStudentExperience() {
      // 构建 label 到 value 的映射对象
      const labelToValue = Object.fromEntries(
        this.importantEventOptions.map(item => [item.dictLabel, item.dictValue])
      );
      let data = {
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "gradeId": this.studentInfo.gradeId,
        "gradeName": this.studentInfo.gradeName,
        "classId": this.studentInfo.classId,
        "className": this.studentInfo.className,
        "schoolYear": this.school.schoolYear,
        "semester": this.school.semester,
        "studentId": this.studentInfo.id,
        "studentName": this.studentInfo.studentName,
        "status": this.ruleForm.experience
          .map(label => labelToValue[label])
          .join(','),
        "remark": this.ruleForm.remarks
      };
      this.post(this.$url.insertStudentExperience, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
      });
    },
    schoolYearChangeHandle(e) {

    },
  }
};
</script>

<style lang="scss" scoped>
@import "./lifeExperienceDialog.scss";
</style>